import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";
import store from "../store";

Vue.use(VueRouter);

const Guard = async (to, from, next) => {
  if (localStorage.getItem("isConsent") == "false") {
    next("/en/consentpdpa");
  } else {
    next();
  }
};
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:lang",
      component: () => import("../layout/full-page.vue"),

      children: [
        {
          path: "/",
          name: "home",
          component: () => import("../views/ProjectVendorList.vue"),
          meta: {
            requiresAuth: false,
          },
          beforeEnter: Guard,
        },
        {
          path: "profile",
          name: "profile",
          component: () => import("../views/Profile.vue"),
          meta: {
            requiresAuth: false,
          },
          beforeEnter: Guard,
        },
        {
          path: "bidding/main/:projectId",
          name: "biddingmain",
          component: () => import("../views/Bidding.vue"),
          meta: {
            requiresAuth: false,
          },
          beforeEnter: Guard,
        },
        {
          path: "plant-address",
          name: "plant-address",
          component: () => import("../views/PlantAddress.vue"),
          meta: {
            requiresAuth: false,
          },
          beforeEnter: Guard,
        },
        {
          path: "consentpdpa",
          name: "consentpdpa",
          component: () => import("../views/ConsentPDPA.vue"),
        },
        {
          path: "consentpdpa/:readonly",
          name: "consentpdpa-readonly",
          component: () => import("../views/ConsentPDPA.vue"),
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS - VENDOR
    // =============================================================================
    {
      path: "/:lang",
      component: () => import("../layout/full-page.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "announcement",
          name: "page-announcement",
          component: () => import("../views/ProjectAnnounce.vue"),
          beforeEnter: Guard,
        },

        {
          path: "login",
          name: "page-login",
          component: () => import("../views/Login.vue"),
        },
        {
          path: "register",
          name: "page-register",
          component: () => import("../views/Register.vue"),
        },
        {
          path: "forgotpassword",
          name: "page-forgotpassword",
          component: () => import("../views/ForgotPassword.vue"),
        },
        {
          path: "vendorguide",
          name: "page-vendorguide",
          component: () => import("../views/VendorGuide.vue"),
          beforeEnter: Guard,
        },
        {
          path: "vendorinfo",
          name: "page-vendorinfo",
          component: () => import("../views/VendorInfo.vue"),
          beforeEnter: Guard,
        },
        {
          path: "error-404",
          name: "page-error-404",
          component: () => import("../views/Error404.vue"),
        },
        {
          path: "alert-login",
          name: "page-alert-login",
          component: () => import("../views/AlertLogin.vue"),
        },
      ],
    },

    // Redirect to 404 page, if no match found
    {
      path: "/",
      redirect: `/${i18n.locale}`,
    },
  ],
});

// Authen template //
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log("store.getters.isLoggedIn", store.getters.isLoggedIn);
    if (store.getters.isLoggedIn) {
      next("/login");
      return;
    }
    console.log("store.getters.isLoggedIn3", store.getters.isLoggedIn);
    next();
  } else {
    console.log("store.getters.isLoggedIn2", store.getters.isLoggedIn);
    next();
  }
});
// Authen template

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
